/**
 * Created by mohameds on 10/7/19.
 */

export const MonitorConst = {
  monitorHeight: 1080,
  category: {
    DYNAMIC_PAGE: 'Dynamic Page',
    SPECIAL_OCCASION: 'Special Occasion'
  },
  Action: {
    DELETE: 'delete',
    GET: 'get',
    PUT: 'put',
    POST: 'POST'
  },
  CurrencyType: {
    CURRENCY: "Currency",
    PERCENTAGE: "Percentage",
    NUMBER: "Number",
  },
  PAGE_ID: {
    AGENCY_NUMBERS: 1,
    AGENCY_CHART: 2,
    DEPARTMENT_NUMBERS: 3,
    INDIVIDUAL_NUMBERS: 4,
    CONGRATULATIONS:5,
    CORE_VALUES: 6,
    HAPPY_BIRTHDAY: 7,
    WELCOME_VISITORS: 8,
    QUOTES: 9,
    DESTINATIONS: 10,
    AGENCY_REVENUE: 11,
    RING_CENTRAL: 12,
    BANNER: 13,
    TOP_SCORER: 14,
  },
  // 8MB = 8*1024*1024
  FILE_SIZE_LIMIT: 8388608,
  COLORS: [
    'AliceBlue', 'AntiqueWhite', 'Aqua', 'Aquamarine', 'Azure', 'Beige', 'Bisque', 'Black', 
    'BlanchedAlmond', 'Blue', 'BlueViolet', 'Brown', 'BurlyWood', 'CadetBlue', 'Chartreuse', 
    'Chocolate', 'Coral', 'CornflowerBlue', 'Cornsilk', 'Crimson', 'Cyan', 'DarkBlue', 
    'DarkCyan', 'DarkGoldenRod', 'DarkGray', 'DarkGrey', 'DarkGreen', 
    'DarkKhaki', 'DarkMagenta', 'DarkOliveGreen', 'DarkOrange', 'DarkOrchid', 'DarkRed', 
    'DarkSalmon', 'DarkSeaGreen', 'DarkSlateBlue', 'DarkSlateGray', 'DarkSlateGrey', 
    'DarkTurquoise', 'DarkViolet', 'DeepPink', 'DeepSkyBlue', 'DimGray', 'DimGrey', 
    'DodgerBlue', 'FireBrick', 'FloralWhite', 'ForestGreen', 'Fuchsia', 'Gainsboro', 
    'GhostWhite', 'Gold', 'GoldenRod', 'Gray', 'Grey', 'Green', 'GreenYellow', 'HoneyDew', 
    'HotPink', 'IndianRed', 'Indigo', 'Ivory', 'Khaki', 'Lavender', 'LavenderBlush', 'LawnGreen', 
    'LemonChiffon', 'LightBlue', 'LightCoral', 'LightCyan', 'LightGoldenRodYellow', 'LightGray', 
    'LightGrey', 'LightGreen', 'LightPink', 'LightSalmon', 'LightSeaGreen', 'LightSkyBlue', 
    'LightSlateGray', 'LightSlateGrey', 'LightSteelBlue', 'LightYellow', 'Lime', 'LimeGreen', 
    'Linen', 'Magenta', 'Maroon', 'MediumAquaMarine', 'MediumBlue', 'MediumOrchid', 
    'MediumPurple', 'MediumSeaGreen', 'MediumSlateBlue', 'MediumSpringGreen', 'MediumTurquoise', 
    'MediumVioletRed', 'MidnightBlue', 'MintCream', 'MistyRose', 'Moccasin', 'NavajoWhite', 
    'Navy', 'OldLace', 'Olive', 'OliveDrab', 'Orange', 'OrangeRed', 'Orchid', 'PaleGoldenRod', 
    'PaleGreen', 'PaleTurquoise', 'PaleVioletRed', 'PapayaWhip', 'PeachPuff', 'Peru', 'Pink', 
    'Plum', 'PowderBlue', 'Purple', 'RebeccaPurple', 'Red', 'RosyBrown', 'RoyalBlue', 
    'SaddleBrown', 'Salmon', 'SandyBrown', 'SeaGreen', 'SeaShell', 'Sienna', 'Silver', 
    'SkyBlue', 'SlateBlue', 'SlateGray', 'SlateGrey', 'Snow', 'SpringGreen', 'SteelBlue', 
    'Tan', 'Teal', 'Thistle', 'Tomato', 'Turquoise', 'Violet', 'Wheat', 'White', 'WhiteSmoke', 
    'Yellow', 'YellowGreen'
  ],
  SCALING: [
    [0.50, '50%'], [0.55, '55%'],
    [0.60, '60%'], [0.65, '65%'],
    [0.70, '70%'], [0.75, '75%'],
    [0.80, '80%'], [0.85, '85%'],
    [0.90, '90%'], [0.95, '95%'],
    [1.00, '100%'], [1.05, '105%'],
    [1.10, '110%'], [1.15, '115%'],
    [1.20, '120%'], [1.25, '125%'],
    [1.30, '130%'], [1.35, '135%'],
    [1.40, '140%'], [1.45, '145%'],
    [1.50, '150%'],
  ]
};


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/Constants.js